<template>
  <div class="avatar">
    <div v-cover-lazy-loader
         :data-src="profile.avatar"
         :data-default-src="'/img/img-default/img-user-default-s.png'"
         :data-hide="true"
         class="avatar-img"
         title="avatar"
         alt="avatar"
         @click="onClick"
    />
  </div>
</template>
<script>
import CoverLazyLoader from '@/directives/CoverLazyLoader'

export default {
  name: 'Avatar',
  components: {},
  directives: {
    CoverLazyLoader
  },
  props: {
    onClick: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    profile() {
      return this.$store.state.user.profile
    }
  },
  methods: {
    imgloaded(e) {
      // console.log('imgloaded', e)
    },
    imgLoadOnError(e) {
      // console.log('imgLoadOnError')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.transparent {
  opacity: 0;
}
.avatar {
  display: inline-block;
  vertical-align: middle;
  width: 36px;
  height: 36px;
  &-img {
    display: inline-block;
    width: 36px;
    height: 36px;
    border: 2px solid $theme-yellow;
    border-radius: 50%;
    cursor: pointer;
    background-color: $grey-ec;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
@media only screen and (min-width: 1440px) {
  // As same as default
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  // As same as default
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  // As same as default
}

@media only screen and (max-width: 767.98px) {
  // As same as default
}
</style>
